import ApiService from "@/services/ApiService"

const PARAMETRO_REPOSITORY_URL = 'Parametro'

const ParametroRepository = {

  checkTelefono(){
    return ApiService.get(`${PARAMETRO_REPOSITORY_URL}/ObtenerTelefono`)
  },

}

export default ParametroRepository